import { createUseStyles } from 'react-jss'
import { colors } from '../colors'

export const style = {
  caption: {
    maxWidth: 1024,
    borderTop: `1px solid ${colors.borderGray}`,
    padding: '10px 0',
    marginTop: 10
  },
  captionText: {
    fontSize: 14,
    textAlign: 'justify',
    color: colors.textGray
  }
}

export const useCaptionStyles = createUseStyles(style)
